import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import SanityPortableText from "./SanityPortableText";
// import { StaticImage } from "gatsby-plugin-image";
import Mailchimp from "./ui/Mailchimp";
import Cover from "./Cover";
import footerPattern from "../images/footer-pattern.svg";
import footerMobilePattern from "../images/footer-mobile-pattern.svg";
import asphaltChroniclesLogo from "../images/asphalt-chronicles-logo.svg";

const query = graphql`
  query {
    # siteBuildMetadata {
    #   buildTime
    # }
    sanityFooter {
      colophon: _rawColophon
    }
  }
`;

const Footer = () => {
  const {
    // siteBuildMetadata: { buildTime },
    sanityFooter: { colophon }
  } = useStaticQuery(query);
  return (
    <footer className='text-sm-lg md:text-lg  h-screen '>
      <div className='inner h-full'>
        <div className='sm-only'>
          <img
            src={footerMobilePattern}
            alt='footer mobile pattern'
            className='w-full'
          />
        </div>

        <div className='md:flex h-full'>
          <div className='scrollY'>
            <div className='px-sm md:p-md'>
              <Mailchimp
                heading='Subscribe to our newsletter:'
                // action='https://agencejfa.us20.list-manage.com/subscribe/post?u=c59b5c96b9d8e4c1943d4786b&amp;id=4047e9357a'
                action='https://kevincouliau.us6.list-manage.com/subscribe/post?u=16e874bbbfba8e847e2d8ac96&id=c4949d1ece'
                fields={[
                  {
                    name: "EMAIL",
                    placeholder: "Enter your email adress here",
                    type: "email",
                    required: true
                  }
                ]}
                className='mailchimp text-base'
              />
              <SanityPortableText input={colophon} />
              <img
                src={asphaltChroniclesLogo}
                alt='asphalt chronicles logo'
                height='43'
                width='160'
              />
            </div>
          </div>

          <div className='deco h-full hidden-sm' style={{ width: "14%" }}>
            <Cover url={footerPattern} />
            {/* <img src={footerPattern} alt='footer pattern' /> */}
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
